import { apiConstants } from '../../apiConstant'
import { formDataCommonFunctionPut } from '../../serviceCall'
import { getUserIdForTicketMutation } from './ticketMutationUserId'

const updateTicketDetail = (data, callback, errorCallBack,params) => {
  
  return async (dispatch) => {
    if (data instanceof FormData) {
      data.delete('user_id')
      data.append('user_id', getUserIdForTicketMutation())
    }
    formDataCommonFunctionPut(data,apiConstants.TICKET.UPDATE_TICKET_DETAIL)
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default updateTicketDetail;